





































































































































































































































































import { autoCompleteCountryCodes } from "@/lib/CountryCodeHelper";
import { emailRule, extendetPhoneRule, disallowUmlaut } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { UserEntity } from "@/models/userEntity";
import { Component, Prop } from "vue-property-decorator";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { ConfigModule } from "@/store/modules/config";

@Component({
  components: {}
})
export default class ProfileFormFields extends DarkModeHighlightMixin {
  @Prop({ default: true })
  showUserNameField!: boolean;

  @Prop()
  user!: UserEntity;

  @Prop()
  disabled!: boolean;

  @Prop({ default: false })
  isResubmitAddress!: boolean;

  @Prop({ default: false })
  isResubmitTaxnumber!: boolean;

  @Prop({ default: false })
  isResubmitAddressEnabled!: boolean;

  @Prop({ default: false })
  isResubmitTaxnumberEnabled!: boolean;

  @Prop({ default: false })
  hideState!: boolean;

  @Prop({ default: false })
  hideCountry!: boolean;

  get isTHGContext() {
    return ConfigModule.appContext === AppContextEnum.THG_PORTAL || ConfigModule.appContext === AppContextEnum.THG;
  }

  get localIsResubmitAddress() {
    return this.isResubmitAddress;
  }
  set localIsResubmitAddress(isResubmitAddress: boolean) {
    this.$emit("update:isResubmitAddress", isResubmitAddress);
  }

  get localIsResubmitTaxnumber() {
    return this.isResubmitTaxnumber;
  }
  set localIsResubmitTaxnumber(isResubmitTaxnumber: boolean) {
    this.$emit("update:isResubmitTaxnumber", isResubmitTaxnumber);
  }

  readonly countryCodes = autoCompleteCountryCodes;

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());
    rules.push(disallowUmlaut());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(extendetPhoneRule());

    return rules;
  }
}
